const skipReasons: Record<string, string> = {
  COOLDOWN: "sent too recently",
  QUIET_HOURS: "quiet hours",
  OFF_SHIFT: "driver off shift",
  NO_ASSIGNED_DRIVER: "no driver assigned",
  DISPATCH_NOT_ACTIVE: "dispatch not active",
  RATE_LIMIT: "too many notifications",
  NOT_ELIGIBLE: "not eligible",
};

/** Plain wording for why a driver notification was or would be skipped. */
export const getNotificationSkipReasonLabel = (reason?: string): string | undefined =>
  reason ? skipReasons[reason] ?? reason.replace(/_/g, " ").toLowerCase() : undefined;
